export default __webpack_public_path__ + "static/media/eng.078d8376.svg";